import { ResponsiveImageConfiguration } from './graphql/api/graphql';

const getDefaultImageUrls = (
  imageConfigurations: ResponsiveImageConfiguration[],
) => imageConfigurations.map(
  () => 'https://fashionunited.com/r/,/https://media.fashionunited.com/media/logos/defaultImageBlackHighonGrey.svg',
);

export default getDefaultImageUrls;
